"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Touch = void 0;
const gl_matrix_1 = require("gl-matrix");
class Touch {
    constructor() {
        this.pressed = false;
        this.position = gl_matrix_1.vec2.create();
        this.delta = gl_matrix_1.vec2.create();
    }
}
exports.Touch = Touch;
